module.exports = __webpack_public_path__ + "img/taiwanTravel.136868d8.png";